import { AuthMessageType, ClientType, ConnectionMessage, ConnectionMessageType, websocket } from '@playcastdotio/Messaging';
import { getPersistentPlayerId } from '../..';
import { authStateStore } from '../../stores';

export const handleConnectionMessage = (message: ConnectionMessage, rawSocket: WebSocket | null) => {
  console.log('Connection message:', message);

  switch (message.type) {
    case ConnectionMessageType.CONN_AUTH_REQUIRED: {
      console.log('Auth required');
      const msg = websocket.generators.auth(AuthMessageType.AUTH_REQUEST, {
        clientType: ClientType.PLAYER,
        persistentId: getPersistentPlayerId(),
        tokenJwt: authStateStore.currentState.accessToken || undefined,
      });
      // Bypass ready check
      rawSocket?.send(JSON.stringify(msg));
    }
  }
};
